// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import FrenchPolynesia from '../_raw/flag/icon_flag_french_polynesia.png';

export default () => <img src={FrenchPolynesia} alt="FrenchPolynesia" />;
